import { IncomingMessage } from "http";
import { URL } from "url";
import { parse } from "cookie";
import {
  toExpressQuery,
  getClientRequestUrl,
} from "@repo/next-utils/server-request-helpers";

export const buildExpressRequestPagesRouter = async (req: IncomingMessage) => {
  const headers = req.headers as Record<string, string>;
  const cookies = parse(headers.cookie || "");

  const headersList = new Headers(Object.entries(headers));
  const url = await getClientRequestUrl(headersList);
  const searchParams = new URL(url).searchParams;
  const query = toExpressQuery(searchParams);

  const get = (name: string) => headers[name.toLowerCase()];

  return {
    request: {
      headers,
      url,
      query,
      get,
      cookies,
    },
  };
};
